import cn from 'classnames';
import { getCellDisplayDateFromString } from '@/condor/ui/common/Layout/helpers';
import TypeCell from '@/finsight/ui/components/creditFlow/articles/common/TypesCell';
import HeadlineCell from '@/finsight/ui/components/creditFlow/articles/common/HeadlineCell';
import SectorIndustryCell from '@/finsight/ui/components/creditFlow/articles/common/SectorIndustryCell/SectorIndustryCell';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import styles from './articlesTile.scss';

const columns = [
  {
    title: 'Sec/Ind',
    name: 'id',
    width: 64,
    maxWidth: 64,
    className: alignStyles.alignCenter,
    cellCallback: (cellProps) => <SectorIndustryCell { ...cellProps } />,
  },
  {
    name: 'headline',
    title: 'Headline',
    className: alignStyles.alignLeft,
    cellCallback: (cellProps) => <HeadlineCell { ...cellProps } />,
  },
  {
    name: '',
    title: 'Type',
    width: 108,
    maxWidth: 108,
    className: alignStyles.alignRight,
    cellCallback: (cellProps) => <TypeCell { ...cellProps } />,
  },
  {
    name: 'publishedAt',
    title: 'date',
    width: 113,
    className: cn(alignStyles.alignRight, styles.dateCell),
    cellCallback: ({ cellData }) => getCellDisplayDateFromString(cellData),
  },
];

export default columns;
